import { render, staticRenderFns } from "./TaxesSelect.vue?vue&type=template&id=49d3333a&"
import script from "./TaxesSelect.vue?vue&type=script&lang=js&"
export * from "./TaxesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports